import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import Avatar from '@atlaskit/avatar';
import { useHydratedValue } from '../../../../state';
import { AvatarWrapper, NameContainer, UserContainer } from './styled';

var User = function User(_ref) {
  var id = _ref.id,
      name = _ref.name,
      fieldName = _ref.fieldName,
      selected = _ref.selected,
      error = _ref.error;

  var _useHydratedValue = useHydratedValue({
    id: id,
    fieldName: fieldName
  }),
      _useHydratedValue2 = _slicedToArray(_useHydratedValue, 1),
      user = _useHydratedValue2[0];

  return /*#__PURE__*/React.createElement(UserContainer, {
    selected: selected,
    error: error
  }, /*#__PURE__*/React.createElement(AvatarWrapper, null, /*#__PURE__*/React.createElement(Avatar, {
    src: user === null || user === void 0 ? void 0 : user.avatarUrl,
    borderColor: "transparent",
    size: "xsmall"
  })), /*#__PURE__*/React.createElement(NameContainer, null, name));
};

export var user = {
  component: User,
  attrs: {
    id: {},
    name: {},
    fieldName: {}
  }
};